import {Layout, Typography, Anchor} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import ValidationLogic from './ValidationLogic';
import ValidationPart2 from './ValidationPart2';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const ValidationPage = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');

  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#HPValidation') {
      setBackI(appColors['ColorE']);
      setBackII('transparent');
    } else {
      setBackI('transparent');
      setBackII(appColors['ColorE']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#HPValidation' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorE'], fontSize: '2.5vh'}}>Potential User</Text></Content>}/>
          <Link href='#ValidationPart2' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorE'], fontSize: '1.9vh'}}>Design to real-life</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorE'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> V&nbsp;<br/> A&nbsp;<br/> L&nbsp;<br/> I&nbsp;<br/> D&nbsp;<br/> A&nbsp;<br/> T&nbsp;<br/> I&nbsp;<br/> O&nbsp;<br/> N&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='HPValidation'>
              <ValidationLogic/>
            </div>
            <div id='ValidationPart2'>
              <ValidationPart2/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ValidationPage;
